// src/components/store/sections/weekly-banner/WeeklyBannerV90PolaroidboardSunsetAmber.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV90PolaroidboardSunsetAmber(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={90}
      archKey="polaroid_board"
      archLabel="Polaroid Promo Board"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      {...props}
    />
  );
}
